import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
} from "date-fns";
import { formatNumber } from "./formatNumber";

/**
 * Persian relative "last updated" label for PDP price cards.
 * e.g. "آخرین بروزرسانی ۵ دقیقه پیش"
 */
export function formatRelativeUpdate(updatedAt: string): string {
  const updated = new Date(updatedAt);
  if (Number.isNaN(updated.getTime())) {
    return "آخرین بروزرسانی --";
  }

  const now = new Date();
  const minutes = Math.max(0, differenceInMinutes(now, updated));

  if (minutes < 1) {
    return "آخرین بروزرسانی چند ثانیه پیش";
  }

  if (minutes < 60) {
    return `آخرین بروزرسانی ${formatNumber(minutes)} دقیقه پیش`;
  }

  const hours = differenceInHours(now, updated);
  if (hours < 24) {
    return `آخرین بروزرسانی ${formatNumber(hours)} ساعت پیش`;
  }

  const days = differenceInDays(now, updated);
  if (days < 7) {
    return `آخرین بروزرسانی ${formatNumber(Math.max(1, days))} روز پیش`;
  }

  const weeks = Math.floor(days / 7);
  if (weeks < 5) {
    return `آخرین بروزرسانی ${formatNumber(weeks)} هفته پیش`;
  }

  return `آخرین بروزرسانی ${formatNumber(days)} روز پیش`;
}
